module.exports = __webpack_public_path__ + "static/pic15-a1f9aca5fb238cd6cbe3a368b6137886.png";